<div [ngClass]="theme.getThemeClass()" class="dispatch-zones" [class.loading-state]="loading">
  <app-system-message></app-system-message>
  @if (loading) {
    <app-loading-element class="loadingElementContainer"></app-loading-element>
  }

  @if (!loading) {
  <div [ngClass]="theme.getThemeClass()" class="zones-header-top">
    <h2 class="zones-title">{{ 'Zones' | translate }}</h2>
    <div class="zones-filter">
      <label for="zonesClientFilter">{{ 'Filter by client' | translate }}</label>
      <select
        id="zonesClientFilter"
        class="form-control"
        [(ngModel)]="selectedClientId"
        (ngModelChange)="onClientFilterChange()"
      >
        <option value="">{{ 'All clients' | translate }}</option>
        @for (client of clients; track client.client_id) {
          <option [value]="client.client_id">{{ client.client_name }}</option>
        }
      </select>
    </div>
  </div>

  <section [ngClass]="theme.getThemeClass()" class="group-list">
    @for (group of groupedDevices; track group.usage) {
      <section [ngClass]="theme.getThemeClass()" class="usage-group">
        <header class="usage-header">
          <h3>{{ group.usage | translate }}</h3>
          <span class="count">{{ group.devices.length }} {{ 'devices' | translate }}</span>
        </header>
        <div class="tile-grid">
          @for (device of group.devices; track device.thing_name) {
            <article [ngClass]="theme.getThemeClass()" class="device-tile" [class.unavailable]="!isDeviceSelectable(device)">
              <div class="tile-top">
                <label class="select-box">
                  <input
                    type="checkbox"
                    [checked]="device.selected"
                    [disabled]="!isDeviceSelectable(device)"
                    (change)="toggleSelection(device)"
                  />
                  <span></span>
                </label>
                @if (device.zone_id && getZoneName(device.zone_id)) {
                  <span class="zone-tag">{{ getZoneName(device.zone_id) }}</span>
                }
              </div>
              <div class="tile-body">
                <button
                  class="text-link device-name"
                  type="button"
                  (click)="openTextOverlay('Device', device.thing_name)"
                >
                  {{ device.thing_name }}
                </button>
                <div class="device-meta">
                  <span style="color: #808080;" class="chip">{{ (device.bin_usage || 'unknown') | translate }}</span>
                  @if (device.bin_name) {
                    <span class="chip muted">{{ device.bin_name }}</span>
                  }
                </div>
                <button
                  class="text-link address"
                  type="button"
                  (click)="openTextOverlay('Address', device.bin_address || 'No address')"
                >
                  {{ (device.bin_address || 'No address') | translate }}
                </button>
              </div>
              <div class="tile-footer">
                <button
                  class="inline-btn"
                  [disabled]="!device.zone_id || !isDeviceSelectable(device)"
                  (click)="removeFromZone(device)"
                >
                  {{ 'Remove from zone' | translate }}
                </button>
                <button
                  class="inline-btn"
                  [disabled]="!isDeviceSelectable(device)"
                  (click)="openAddToZoneModal(device)"
                >
                  {{ (device.zone_id ? 'Change zone' : 'Add to zone') | translate }}
                </button>
              </div>
            </article>
          }
        </div>
      </section>
    }
  </section>
  }

  <header [ngClass]="theme.getThemeClass()" class="zones-header">
    <div class="actions">
      <button class="btn" (click)="openZonesMapModal()">{{ 'View Zones' | translate }}</button>
      <button class="btn" [disabled]="selectedDevices.length === 0" (click)="openAddToZoneModal()">
        {{ (getSelectionZoneId() ? 'Change zone' : 'Add to zone') | translate }}
      </button>
      <button class="btn primary" [disabled]="selectedDevices.length === 0" (click)="openCreateZoneModal()">
        {{ 'Create Zone' | translate }}
      </button>
      <button class="btn ghost" [disabled]="zones.length === 0" (click)="openDeleteZoneModal()">
        {{ 'Delete Zones' | translate }}
      </button>
      <button class="btn ghost" [disabled]="selectedDevices.length === 0" (click)="clearSelection()">
        {{ 'Clear Selection' | translate }}
      </button>
    </div>
  </header>

  @if (showAddToZoneModal) {
    <div class="modal-backdrop" (click)="closeModals()"></div>
    <div class="modal">
      <h3>{{ 'Add To Zone' | translate }}</h3>
      <select class="form-control" [(ngModel)]="selectedZoneId">
        <option value="" disabled selected>{{ 'Select a zone' | translate }}</option>
        @for (zone of zones; track zone.zone_id) {
          <option [value]="zone.zone_id">{{ zone.zone_name }}</option>
        }
      </select>
      <div class="modal-actions">
        <button class="btn ghost" (click)="closeModals()">{{ 'Cancel' | translate }}</button>
        <button class="btn primary" [disabled]="!selectedZoneId" (click)="addSelectedToZone()">
          {{ 'Add' | translate }}
        </button>
      </div>
    </div>
  }

  @if (showCreateZoneModal) {
    <div class="modal-backdrop" (click)="closeModals()"></div>
    <div class="modal">
      <h3>{{ 'Create Zone' | translate }}</h3>
      <label>{{ 'Zone Name' | translate }}</label>
      <input class="form-control" [(ngModel)]="newZoneName" type="text" />
      <label>{{ 'Waste Type' | translate }}</label>
      <select class="form-control" [(ngModel)]="newWasteType">
        <option value="" disabled selected>{{ 'Select waste type' | translate }}</option>
        @for (waste of binUsage; track waste.value) {
          <option [value]="waste.value">{{ waste.label | translate }}</option>
        }
      </select>
      <label>{{ 'Zone Color' | translate }}</label>
      <input class="form-control color-input" [(ngModel)]="newZoneColor" type="color" />
      <div class="modal-actions">
        <button class="btn ghost" (click)="closeModals()">{{ 'Cancel' | translate }}</button>
        <button class="btn primary" [disabled]="!newZoneName" (click)="createZoneFromSelection()">
          {{ 'Create' | translate }}
        </button>
      </div>
    </div>
  }

  @if (showZonesMapModal) {
    <div class="modal-backdrop" (click)="closeModals()"></div>
    <div class="modal large">
      <h3>{{ 'Zones Map' | translate }}</h3>
      <div #zonesMap class="zones-map"></div>
      <div class="modal-actions">
        <button class="btn" (click)="closeModals()">{{ 'Close' | translate }}</button>
      </div>
    </div>
  }

  @if (showDeleteZoneModal) {
    <div class="modal-backdrop" (click)="closeModals()"></div>
    <div class="modal">
      <h3>{{ 'Delete Zones' | translate }} ({{ totalZoneCount }})</h3>
      <p class="warning-text">
        {{ 'Deleting zones may interfere with automated collection routing.' | translate }}
      </p>
      <div class="zone-delete-list">
        @for (zone of zones; track zone.zone_id) {
          <label class="zone-delete-item">
            <input
              type="checkbox"
              [checked]="selectedZoneIds.has(zone.zone_id)"
              (change)="toggleZoneSelection(zone.zone_id, $event.target.checked)"
            />
            <span class="zone-delete-name">{{ zone.zone_name }}</span>
            <span class="zone-delete-count">
              {{ getZoneDeviceCount(zone.zone_id) }} {{ 'devices' | translate }}
            </span>
          </label>
        }
      </div>
      <div class="modal-actions">
        <button class="btn ghost" (click)="closeModals()">{{ 'Cancel' | translate }}</button>
        <button
          class="btn primary"
          [disabled]="selectedZoneIds.size === 0"
          (click)="deleteSelectedZones()"
        >
          {{ 'Delete' | translate }}
        </button>
      </div>
    </div>
  }

  @if (showTextOverlay) {
    <div class="modal-backdrop" (click)="closeTextOverlay()"></div>
    <div class="modal text-overlay">
      <h3>{{ overlayTitle | translate }}</h3>
      <p class="overlay-text">{{ overlayText }}</p>
      <div class="modal-actions">
        <button class="btn ghost" (click)="closeTextOverlay()">{{ 'Close' | translate }}</button>
      </div>
    </div>
  }
</div>
